// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"c9dded8e","242":"99cd9714","524":"33e2f4e3","620":"9e732b62","761":"dfcf6bfc","847":"6c5a770f"}[chunkId] + ".chunk.css";
};